import React, { useState } from "react";
import {
  Box,
  InputField,
  SubmitButton,
  TextComponent,
  TextareaField,
} from "../../../../components";
import { useLocation } from "react-router-dom";
import styles from "./Screen5.module.css";
import { BiSolidPlusCircle } from "react-icons/bi";
import Modal from "../../../../components/modal/Modal";
import { showAlert } from "../../../../Store/Actions/GeneralActions";
import { useDispatch, useSelector } from "react-redux";
import { List } from "antd";
import { EventMiddleware } from "../../../../Store/Middlewares/EventMiddleware";
import { CgClose } from "react-icons/cg";
// import { backgroundImage } from 'html2canvas/dist/types/css/property-descriptors/background-image';
const Screen5 = ({ setCurrentStep }) => {
  const WeddingWeb = useSelector((state) => state.EventReducer.WeddingWeb);
  const [isModalOpen, setIsModalOpen] = useState(
    WeddingWeb?.get_informed?.length > 0 ? false : true
  );
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [question, setquestion] = useState("");
  const [id, setId] = useState();
  const [answer, setAnswer] = useState("");
  const [detailsArr, setDetailsArr] = useState(
    WeddingWeb?.get_informed?.length > 0 ? WeddingWeb?.get_informed : []
  );
  // const [editItem, setEditItem] = useState();
  console.log("detailsArrr", detailsArr);
  const dispatch = useDispatch();
  const onClickNext = () => {
    if (detailsArr.length == 0) {
      dispatch(
        showAlert({
          type: "Error",
          message: "Please Add atleast one detail",
        })
      );
    } else {
      dispatch(
        EventMiddleware.postWeddingWebsite({
          step: 5,
          weddingWebId: WeddingWeb?.id,
          detailsArr,
        })
      ).then(() => setCurrentStep((prev) => prev + 1));
    }
  };
  const saveDetails = () => {
    if (!question || !answer) {
      dispatch(
        showAlert({
          type: "Error",
          message: "All fields are mandatory",
        })
      );
    } else {
      let dummyArr = [...detailsArr];
      dummyArr.push({
        id: detailsArr?.length + 1,
        question: question,
        answer: answer,
      });
      setDetailsArr(dummyArr);
      setIsModalOpen(false);
      setquestion("");
      setAnswer("");
      setId();
    }
  };
  const onClickEditBtn = (item) => {
    setIsEditModalOpen(true);
    setId(item?.id);
    setquestion(item?.question);
    setAnswer(item?.answer);
  };
  const editDetails = () => {
    let data = {
      id: id,
      question: question,
      answer: answer,
    };
    let index = detailsArr.findIndex((item) => item?.id == id);
    setDetailsArr((prev) => {
      prev.splice(index, 1, data);
      return prev;
    });
    setIsEditModalOpen(false);
    setquestion("");
    setAnswer("");
    setId();
  };

  const renderItem = (item, index) => {
    return (
      <div className={styles.listItem} key={index}>
        <CgClose
          className={styles.crossIcon}
          size={20}
          onClick={() => {
            setDetailsArr((prev) => {
              let newArr = [...prev];
              newArr.splice(index, 1);
              return newArr;
            });
          }}
        />
        <TextComponent text={item?.question} textClass={styles.title} />
        <TextComponent text={item?.answer} textClass={styles.desc} />
        <TextComponent
          text={"Edit"}
          textClass={styles.editBtn}
          onClick={() => onClickEditBtn(item)}
        />
      </div>
    );
  };
  return (
    <>
      <div className={styles.content}>
        <div className={styles.textCont}>
          <TextComponent text={"Get Informed"} />
        </div>
      </div>
      {detailsArr && (
        <div className={styles.listDiv}>
          <List
            grid={{ lg: 2, xxl: 2, xl: 2, xs: 1, md: 2, sm: 1 }}
            dataSource={detailsArr}
            renderItem={renderItem}
            className={styles.list}
          />
        </div>
      )}
      <div className={styles.content}>
        <div className={styles.addBtn} onClick={() => setIsModalOpen(true)}>
          <BiSolidPlusCircle className={styles.addIcon} />
          <TextComponent text={"Add"} />
        </div>
        <div className={styles.nextBtn}>
          <SubmitButton title={"Next"} onClick={onClickNext} />
        </div>
      </div>

      <Modal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        closable={true}
        pinkBg={true}
        // wideModal={true}
        className={styles.modalContent}
      >
        <div className={styles.modalDiv}>
          <InputField
            placeholder={"Question"}
            onChange={(e) => setquestion(e.target.value)}
            value={question}
          />
          <TextareaField
            placeholder={"Answer"}
            onChange={(e) => setAnswer(e.target.value)}
            value={answer}
          />
          <div className={styles.btnDiv}>
            <SubmitButton
              title={"Save"}
              btnClass={styles.saveBtn}
              onClick={saveDetails}
            />
          </div>
        </div>
      </Modal>
      <Modal
        isModalOpen={isEditModalOpen}
        setIsModalOpen={setIsEditModalOpen}
        closable={true}
        pinkBg={true}
        onClose={() => {
          setId();
          setquestion("");
          setAnswer("");
        }}
        // wideModal={true}
        className={styles.modalContent}
      >
        <div className={styles.modalDiv}>
          <InputField
            placeholder={"Question"}
            onChange={(e) => setquestion(e.target.value)}
            value={question}
          />
          <TextareaField
            placeholder={"Answer"}
            onChange={(e) => setAnswer(e.target.value)}
            value={answer}
          />
          <div className={styles.btnDiv}>
            <SubmitButton
              title={"Save"}
              btnClass={styles.saveBtn}
              onClick={editDetails}
            />
          </div>
        </div>
      </Modal>
    </>
  );
};

export default Screen5;
